export default "как\nПочему\nСколько\nкак"